var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.5 0A7.51 7.51 0 0 0 3 7.5c0 5.384 6.988 12.128 7.284 12.413a.31.31 0 0 0 .432 0C11.013 19.628 18 12.884 18 7.5A7.51 7.51 0 0 0 10.5 0m0 10.938a3.438 3.438 0 1 1 0-6.876 3.438 3.438 0 0 1 0 6.876"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMarker;